<template>
  <div class="ops-map">
    <l-map
      :zoom="zoom"
      :center="coords && coords['lat'] ? coords : center"
      :max-bounds="maxBounds"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker
        v-for="car in carsList"
        :key="car.id"
        :lat-lng="car.coords || ['', '']"
      >
        <l-icon>
          <div class="headline">
            {{ car.state_numbers }}
          </div>
          <img src="@/assets/img/red_truck_big.svg" />
        </l-icon>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { LIcon, LMap, LMarker, LTileLayer } from 'vue2-leaflet'
import { MAP_CENTER } from './constants'

export default {
  name: 'OneCarMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  props: {
    currentPerson: {
      type: Object,
      default: () => {},
    },
    coords: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      zoom: 8,
      center: MAP_CENTER,
      minZoom: 4,
      maxZoom: 13,
      maxBounds: [
        [42.1804258, -15.29296875],
        [77.77369, 227.109375],
      ],
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>',
    }
  },
  computed: {
    carsList() {
      const coords = this.coords && this.coords['lat'] ? this.coords : null

      return [
        {
          id: 0,
          coords,
          state_numbers: this.currentPerson.auto.state_numbers,
        },
      ]
    },
  },
}
</script>

<style lang="sass">
.ops-map
  height: 80vh
  .headline
    white-space: nowrap
    color: red
    font-weight: bold
</style>
